import React from 'react';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import CreditManager from './CreditManager';

const Layout: React.FC = () => {
  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      minHeight: '100vh',
      width: '100%',
      maxWidth: 'none'
    }}>
      <Header />
      <Box component="main" sx={{ flex: 1, width: '100%', maxWidth: 'none' }}>
        <Outlet />
      </Box>
      <Footer />
      <CreditManager />
    </Box>
  );
};

export default Layout; 